import CButton from '@app/components/Common/CButton';
import { COLORS } from '@app/constants/STYLES';
import React, { useContext } from 'react';

import { useMitOrder } from '@app/hooks/trade/mitorder.tsx';
import { useTradeModalStore } from '@app/hooks/trade/modalStore';
import { useTradePosition } from '@app/hooks/trade/tradePosition';
import useWindowDimensions from '@app/hooks/useWindowDimensions';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { View } from '../../../../../styles/reactnative';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import useCloseAllStore from '../closeAllStore';
import { TradeDetailHeaderSection } from '../styles';
import TradeShare from './TradeShare';

const TradeDetailHeader = React.forwardRef<
  HTMLDivElement,
  { tabs: string; setTabs: (tab: string) => void; activedataLength?: any }
>(({ tabs, setTabs, activedataLength }, ref) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const { textw } = useContext(ThemeContext).theme.COLORS;

  const {
    data: pos_list,
    orderlist: activeOrder,
    tpslList,
    mitLengtht,
  } = useTradePosition();
  const { mitDataLength } = useMitOrder();
  const openpositioncount = ' (' + (pos_list?.length || 0) + ')';
  const activecount = ' (' + (activeOrder?.length + mitDataLength || 0) + ')';

  const data = [
    'positions',
    'openOrders',
    'positionHistory',
    'TradeHistory',
    // "cancel",
    'orderhistory',
    'transactionHistory',
  ];
  const { data: tradeModalStore, mutate: muateTradeModalStore } =
    useTradeModalStore();

  // const closed = useCloseAllStore((state) => state.closed);
  const toggleClosed = useCloseAllStore((state) => state.toggleClosed);

  return (
    <TradeDetailHeaderSection ref={ref} className="drag-handle-positions">
      {/*<FloatBtnSection3 style={{ marginRight: 20 }} className={"drag-handle"}>*/}
      {/*	<IconArrowsMove />*/}
      {/*</FloatBtnSection3>*/}
      {/*<FloatBtnSection3*/}
      {/*	className="widgetClose"*/}
      {/*	onClick={() => {*/}
      {/*		muateTradeModalStore({*/}
      {/*			...tradeModalStore,*/}
      {/*			detailshow: tradeModalStore?.detailshow ? false : true,*/}
      {/*		});*/}
      {/*	}}*/}
      {/*>*/}
      {/*	X*/}
      {/*</FloatBtnSection3>*/}
      <View style={{ flexDirection: 'row' }}>
        {data.map((item, index) => (
          <CButton
            key={index.toString()}
            title={
              t(item) +
              (item === 'openOrders'
                ? activecount
                : item === 'positions'
                  ? openpositioncount
                  : '')
            }
            onClick={() => {
              setTabs(item);
            }}
            textHover={'#fff'}
            style={{
              padding: '12px 7px 17px 7px',
              marginRight: 10,
              color: tabs === item ? '#fff' : '#777986',
              borderBottomWidth: 2,
              borderBottomColor: tabs === item ? '#07D993' : 'transparent',
              borderRadius: 0,
              fontSize: width > 900 ? 14 : width > 600 ? 10 : 8,
              cursor: 'pointer',
              fontFamily: 'NanumSquareRound',
              fontWeight: 700,
            }}
          />
        ))}
      </View>

      {tabs === 'positions' && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            marginRight: 16,
            position: 'relative',
            bottom: 4,
          }}
        >
          <Tooltip title={t('currentTooltip')}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                cursor: 'pointer',
              }}
              onClick={() => {
                muateTradeModalStore({
                  ...tradeModalStore,
                  iscurrent: !tradeModalStore?.iscurrent,
                });
              }}
            >
              <div
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: 4,
                  backgroundColor: tradeModalStore?.iscurrent
                    ? '#07d993'
                    : 'transparent',
                  border: tradeModalStore?.iscurrent
                    ? 'none'
                    : '1px solid #777986',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {tradeModalStore?.iscurrent && (
                  <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
                    <path
                      d="M10.3198 4.03711C10.5749 3.7873 10.9874 3.78752 11.2426 4.03711C11.4996 4.2888 11.4996 4.6985 11.2426 4.9502L6.12542 9.96289C5.99762 10.0879 5.83043 10.1503 5.66448 10.1504C5.49831 10.1504 5.33051 10.0881 5.20257 9.96289L2.75725 7.56738C2.50029 7.31569 2.50029 6.90599 2.75725 6.6543C3.01245 6.40444 3.42495 6.40438 3.68011 6.6543L5.6635 8.59668L10.3198 4.03711Z"
                      fill="white"
                      stroke="white"
                      strokeWidth="0.3"
                    />
                  </svg>
                )}
              </div>
              <span
                style={{
                  fontFamily: 'NanumSquareRound',
                  fontSize: 12,
                  color: textw,
                  letterSpacing: '-0.36px',
                }}
              >
                {t('current')}
              </span>
            </div>
          </Tooltip>
          <div
            style={{
              width: 64,
              height: 24,
              border: '1px solid #353535',
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              muateTradeModalStore({
                ...tradeModalStore,
                iscurrent: false,
              });

              setTimeout(() => {
                toggleClosed();
              }, 1000);
            }}
          >
            <span
              style={{
                fontFamily: 'NanumSquareRound',
                fontSize: 12,
                color: '#b3b5bd',
                letterSpacing: '-0.36px',
              }}
            >
              {t('closeAll')}
            </span>
          </div>
        </div>
      )}

      {/* {tabs === "TradeHistory" && <TradeShare/>} */}
    </TradeDetailHeaderSection>
  );
});

TradeDetailHeader.displayName = 'TradeDetailHeader';

export default React.memo(TradeDetailHeader);
